export default __webpack_public_path__ + "static/media/cancelMenu.c7ea27a8.svg";